// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Z4PE","name":"Header_name__3flhu","birthday":"Header_birthday__tYbYa","skeleton":"Header_skeleton__ZnTJ8"};